import { createListenerMiddleware } from '@reduxjs/toolkit';
import { logout } from '../features/auth/logoutSlice';
import { persistor } from './store'; 

export const clearReduxStorageMiddleware = createListenerMiddleware();

clearReduxStorageMiddleware.startListening({
  actionCreator: logout,
  effect: async (action, listenerApi) => {
    listenerApi.dispatch({ type: 'RESET_REDUX_STATE' });

    try {
      await persistor.purge(); 
      window.location.reload();
    } catch (error) {
      console.error(error);
    }
  },
});

export default clearReduxStorageMiddleware;
